import { useCallback } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import debounce from 'lodash.debounce';

function useFilter() {
  const [currentTopic, setCurrentTopic] = useQueryParam('topic', StringParam);
  const [currentFilter, setCurrentFilter] = useQueryParam(
    'filter',
    StringParam,
  );
  const [currentQuery, setCurrentQuery] = useQueryParam('q', StringParam);

  const debounceFn = useCallback((val: string) => {
    setCurrentQuery(val);
  }, []);

  const updateSearchQuery = debounce(debounceFn, 500);

  return {
    topic: {
      current: currentTopic?.toLowerCase(),
      set: setCurrentTopic,
    },
    filterBy: {
      current: currentFilter?.toLowerCase(),
      set: setCurrentFilter,
    },
    search: {
      current: currentQuery?.toLowerCase(),
      set: updateSearchQuery,
    },
  };
}

export default useFilter;
